import authorized from './authorized.tpl';
import unauthorized from './unauthorized.tpl';

const templates = { authorized, unauthorized };

export default templates;



// WEBPACK FOOTER //
// ./daily/assets/id/header/desktop/templates/index.js